import { uniGetValue } from './get-value';
export const isDefined = (value) => typeof value !== 'undefined';
export const isNull = (value) => value === null;
export const isArray = (value) => Array.isArray(value);
export const isObject = (value) => typeof value === 'object' && value !== null && !isArray(value);
export const isString = (value) => typeof value === 'string';
export const isBoolean = (value) => typeof value === 'boolean';
export function isEmptyString(value) {
  return isDefined(value) && (isString(value) && value === '');
}
export function isEmpty(value) {
  return isDefined(value) && ((isArray(value) && value.length === 0)
    || (isObject(value) && Object.keys(value).length === 0)
    || (isString(value) && value === '')
    || isNull(value));
}
export function isJSON(value) {
  try {
    JSON.parse(value);
  }
  catch (e) {
    return false;
  }
  return isString(value);
}
export function isNestedData(value) {
  return isArray(value) || isObject(value);
}
export function uniIsEqual(state, value) {
  return isNestedData(state)
    ? JSON.stringify(state) === (isNestedData(value) ? JSON.stringify(value) : value)
    : uniGetValue(state) === uniGetValue(value);
}
export function uniStringifyEqual(value, equal) {
  return isNestedData(value) ? JSON.stringify(value) === equal : value === uniGetValue(equal);
}
export function uniStringifyNoEqual(value, noEqual) {
  return isNestedData(value) ? JSON.stringify(value) !== noEqual : value !== uniGetValue(noEqual);
}
export function isBind(value, start = '{{', end = '}}') {
  return isString(value) && value.includes(start) && value.includes(end);
}
// export function isBinding(value, start = '{{', end = '}}'): boolean {
//   return isDefined(value) && isBind(value, start, end);
// }
// export function isNotBinding(value, start = '{{', end = '}}'): boolean {
//   return isDefined(value) && !isBind(value, start, end);
// }
// export function isCleanNotBinding(value, start = '{{', end = '}}'): boolean {
//   return !isDefined(value) || !isBind(value, start, end);
// }
// export function isCleanNotBindings(values, start = '{{', end = '}}'): boolean {
//   return values.every((value) => isCleanNotBinding(value, start, end));
// }
